import { createAction, props } from '@ngrx/store';

export const loadFavourites = createAction(
  '[Tep-Species] Load Favourites',
  props<{ caabCodes: number[] }>(),
);

export const toggleFavourite = createAction(
  '[Tep-Species] Toggle Favourite',
  props<{ caabCode: number }>(),
);
